export default __webpack_public_path__ + "static/media/frequency.279f651d.svg";